export const commercialsData = [
  // Celebrity Brand Campaigns (Top Priority)
  {
    id: 1,
    title: "Goodknight",
    brand: "Goodknight ft. Kareena Kapoor Khan",
    vimeoId: "648107484",
    thumbnail: "https://i.vimeocdn.com/video/1305483066-c10da205d61f1b2ed41e77fc69e5ea6bf9eeca02637befcd3_640x360.jpg",
    duration: "00:58",
    category: "Celebrity Brand Campaign"
  },
  {
    id: 2,
    title: "Mother Dairy",
    brand: "Mother Dairy ft. Tisca Chopra",
    vimeoId: "648103195",
    thumbnail: "https://i.vimeocdn.com/video/1305468181-1eaf91df1fbff031f7d2fe7a39364ba4ec80694e37db96b43_640x360.jpg",
    duration: "01:50",
    category: "Celebrity Brand Campaign"
  },
  {
    id: 3,
    title: "Singleton Social",
    brand: "Singleton ft. Shibani Dandekar",
    vimeoId: "887207425",
    thumbnail: "https://i.vimeocdn.com/video/1757648757-8374ffd4a5b6c5b7b3ee039932cf12f3aa902420d64d2703fef21f9465b4b4ca-d_640x360.jpg",
    duration: "00:45",
    category: "Lifestyle & Beverage"
  },
  {
    id: 11,
    title: "TSC x Seema Aunty",
    brand: "The Sleep Company Commercial",
    youtubeId: "hZyAwA2Qv-k",
    thumbnail: "https://img.youtube.com/vi/hZyAwA2Qv-k/maxresdefault.jpg",
    duration: "00:51",
    category: "Celebrity Brand Campaign"
  },
  {
    id: 19,
    title: "Goodknight Durga",
    brand: "Celebrating the Durga in Every Mother",
    youtubeId: "1BTb5ankYoE",
    thumbnail: "https://img.youtube.com/vi/1BTb5ankYoE/maxresdefault.jpg",
    duration: "00:35",
    category: "Celebrity Brand Campaign"
  },

  // Luxury & Lifestyle
  {
    id: 4,
    title: "Jaquar Whirlpool",
    brand: "Jaquar Whirlpool Bathtub",
    vimeoId: "982441717",
    thumbnail: "https://i.vimeocdn.com/video/1897795428-5991f6357eb1781c81563b0bf10adef0041c89fc6924885359b1815a98c89a58-d_640x360.jpg",
    duration: "00:50",
    category: "Luxury Products"
  },

  // Social Impact
  {
    id: 5,
    title: "Surf Excel Holi",
    brand: "Surf Excel - Old Age Home Film",
    vimeoId: "530363748",
    thumbnail: "https://i.vimeocdn.com/video/1097936646-953b72817d300d7af3579ab820eb9bb8254fe4ad415bdc1bbe6cb80fd3f05e44-d_640x360.jpg",
    duration: "01:57",
    category: "Social Impact"
  },

  // Health & Wellness
  {
    id: 6,
    title: "Sugarfree Green",
    brand: "Sugarfree Green - New Year Resolution",
    vimeoId: "691786077",
    thumbnail: "https://i.vimeocdn.com/video/1400318358-280adf639134e39a4f6901f7aefe5e666b7f8be4008ce9afb9944af73a42799c-d_640x360.jpg",
    duration: "01:31",
    category: "Health & Wellness"
  },

  // Corporate
  {
    id: 7,
    title: "Navneet 60 Years",
    brand: "Navneet - 60 Years Celebration",
    vimeoId: "648097525",
    thumbnail: "https://i.vimeocdn.com/video/1305442867-84ceda111149456e029c61e4ce8b6c8fb6fb37ffbc36094e2_640x360.jpg",
    duration: "01:55",
    category: "Corporate"
  },

  // Technology
  {
    id: 8,
    title: "TATA NEU All-in-One",
    brand: "TATA NEU - All In One",
    vimeoId: "814571178",
    thumbnail: "https://i.vimeocdn.com/video/1648121284-6f7b9aba36b279f7eb994cd468e056895dc5d1c6f63fddb0c9a82ec4bbd99b1f-d_640x360.jpg",
    duration: "00:20",
    category: "Technology & Apps"
  },
  {
    id: 10,
    title: "TATA NEU NeuCoin",
    brand: "TATA NEU - 1 NeuCoin 1 Rupee",
    vimeoId: "814571225",
    thumbnail: "https://i.vimeocdn.com/video/1648121467-2b23d4084367d78ca3e756bf84392f86146076f90b8aafac51b00f675929840b-d_640x360.jpg",
    duration: "00:20",
    category: "Technology & Apps"
  },

  // Food & Beverage - Moi Soi
  {
    id: 13,
    title: "Moi Soi",
    brand: "Moi Soi - Hostel Film",
    youtubeId: "0BL2ar-yU4c",
    thumbnail: "https://img.youtube.com/vi/0BL2ar-yU4c/maxresdefault.jpg",
    duration: "00:31",
    category: "Food & Beverage"
  },
  {
    id: 14,
    title: "Moi Soi Baa",
    brand: "Moi Soi - Baa Film",
    youtubeId: "G8SMHEfPoPs",
    thumbnail: "https://img.youtube.com/vi/G8SMHEfPoPs/maxresdefault.jpg",
    duration: "00:31",
    category: "Food & Beverage"
  },
  {
    id: 15,
    title: "Moi Soi Housewife",
    brand: "Moi Soi - Housewife Film",
    youtubeId: "YmKaQDzwOcI",
    thumbnail: "https://img.youtube.com/vi/YmKaQDzwOcI/maxresdefault.jpg",
    duration: "00:30",
    category: "Food & Beverage"
  },

  // iD Foods - Moved to Bottom
  {
    id: 9,
    title: "iD Filter Coffee",
    brand: "iD Filter Coffee - Liquid Coffee at Home",
    vimeoId: "515348939",
    thumbnail: "https://i.vimeocdn.com/video/1067174943-043edaf5c0012bb89ad56d2784f5b5ee1d6e3db0a0113fd07ec8cc1607836ddf-d_640x360.jpg",
    duration: "00:37",
    category: "Food & Beverage"
  },
  {
    id: 22,
    title: "iD Foods",
    brand: "iD presents Little Big Heroes",
    youtubeId: "0LHpEaQvs0c",
    thumbnail: "https://img.youtube.com/vi/0LHpEaQvs0c/hqdefault.jpg",
    duration: "02:17",
    category: "Food & Beverage"
  }
];